angular.module('LegendSettings').controller('LegendModalController', ['$scope', '$uibModalInstance', '$filter', '$timeout', 'data', function ($scope, $uibModalInstance, $filter, $timeout, data) {
  'use strict';
  $scope.colorSets = data.colorSets;
  $scope.legend = data.legend ? angular.copy(data.legend) : {};
  $scope.type = data.type;
  $scope.indicatorType = data.indicatorType;
  $scope.selectedColorSet = data.selectedColorSet ? data.selectedColorSet : {};
  $scope.scales = [];
  $scope.districts = data.districts;

  $scope.updateDistrictLegend = function() {
    if ($scope.legend.districtLegend && $scope.legend) {
      if(!$scope.legend.scales) {
        $scope.legend.scales = {};
      }

      angular.forEach($scope.districts, function (district, idx) {
        if(!$scope.legend.scales[idx]) {
          $scope.legend.scales[idx] = {
            text: district.key
          };
        } else {
          $scope.legend.scales[idx].text = $scope.legend.scales[idx].text ? $scope.legend.scales[idx].text : $scope.districts[idx].key;
        }
      });
    } else if ($scope.legend.districtLegend === false) {
      delete $scope.legend.scales;
    }
  };

  $scope.selectColorSet = function (colorSet) {
    $scope.selectedColorSet = colorSet;
    $scope.legend.colorSet = colorSet.uid;
  };

  $scope.hasErrors = false;

  var errorCheck = function () {
    $scope.hasErrors = jQuery('.has-error').length > 0;
  };

  /**
   * Closes the creation modal window
   */
  $scope.close = function () {
    $scope.legend = data.legend;
    $uibModalInstance.dismiss('cancel');
  };

  /**
   * Closes the modal window and returns the data for the new legend
   * @param {object} legend object consisting of title and category id
   */
  $scope.create = function (legend) {
    if (legend.districtLegend) {
      if (!Array.isArray(legend.scales)) {
        var tempScales = [];
        Object.keys(legend.scales).forEach(function (idx) {
          tempScales.push(legend.scales[idx]);
        });

        legend.scales = tempScales;
      }

      legend.scales.map(function (item, idx) {
        item.district = data.districts[idx].key;
      });
    }
    if (errorCheck()) {
      $scope.hasErrors = true;
    } else {
      $scope.hasErrors = false;
      $uibModalInstance.close(legend);
    }
  };
}]);
